"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_ARTICLE_PROPERTIES = void 0;
exports.ALL_ARTICLE_PROPERTIES = undefined;
//# sourceMappingURL=ArticleProperties.js.map